export type CalendarEmptyState = 'connect' | 'syncing' | 'empty' | 'none';

export function resolveCalendarEmptyState(args: {
  connected: boolean;
  initialSyncComplete: boolean;
  hasEvents: boolean;
  /**
   * #5566: true while the accounts fetch is still in flight (pre-fetch window).
   * `connected` resets to a non-authoritative default on every mount and only
   * becomes true once accounts resolve, so `!connected` during this window means
   * "unknown", not "disconnected". Optional so existing callers keep prior
   * behavior; defaults to not-loading.
   */
  loadingAccounts?: boolean;
}): CalendarEmptyState {
  if (args.hasEvents) return 'none';
  // Don't collapse the pre-fetch 'unknown' state into the 'connect' onboarding
  // CTA — that renders literally-wrong "Connect your calendar" copy for an
  // already-connected user landing on an empty view. Defer the empty-state
  // decision (render just the grid) until the accounts fetch settles.
  if (!args.connected) {
    if (args.loadingAccounts) return 'none';
    return 'connect';
  }
  if (!args.initialSyncComplete) return 'syncing';
  return 'empty';
}
